var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegende(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende__Icn/40px/Legende",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Legende__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18,11 L32,11 L32,13 L18,13 L18,11 Z M18,19 L32,19 L32,21 L18,21 L18,19 Z M18,27 L32,27 L32,29 L18,29 L18,27 Z M13,9 L9,9 C8.44771525,9 8,9.44771525 8,10 L8,14 C8,14.5522847 8.44771525,15 9,15 L13,15 C13.5522847,15 14,14.5522847 14,14 L14,10 C14,9.44771525 13.5522847,9 13,9 Z M12,11 L12,13 L10,13 L10,11 L12,11 Z M11,17 C9.34314575,17 8,18.3431458 8,20 C8,21.6568542 9.34314575,23 11,23 C12.6568542,23 14,21.6568542 14,20 C14,18.3431458 12.6568542,17 11,17 Z M11,19 C11.5522847,19 12,19.4477153 12,20 C12,20.5522847 11.5522847,21 11,21 C10.4477153,21 10,20.5522847 10,20 C10,19.4477153 10.4477153,19 11,19 Z M10.1531726,25.0377337 L7.6531726,29.5412622 C7.32072205,30.2061633 7.80421777,30.9884758 8.54759979,30.9884758 L13.5475998,30.9884758 C14.2909818,30.9884758 14.7744775,30.2061633 14.442027,29.5412622 L11.942027,25.0377337 C11.5735027,24.3006851 10.5216969,24.3006851 10.1531726,25.0377337 Z M11.0475998,27.3883133 L11.9285998,28.9884758 L10.1655998,28.9884758 L11.0475998,27.3883133 Z",
    id: ".._.._src_svg_Icn_40px_Legende__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegende);
export default __webpack_public_path__ + "static/media/Legende.04deb64fa3098be734cdcddaeed43ba8.svg";
export { ForwardRef as ReactComponent };